<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 ">
  <loading v-if="loadingState" />


  <!--  CHECK DL AND SAVE IF NO PAID YET ******************************************************************************************************************** -->
  <div v-if="item.dl == '0' && item.status == '1' && item.payment_id == 0" class="container mb-5 pb-5">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <div class="col-md-12  text-left">
        <h3 class="Regular h0 widthFull"><b>Pratica N. {{item.code}} </b></h3>
      </div>

      <div class="col-md-12 center mb-3 text-center">
        <h4 class="Regular text-center h0 widthFull "><b>Avvertenza per Decreto Legge dell’11 Novembre 2021 n. 157 relativo al contrasto alle frodi  </b></h4>
        <p class="black mt-0 text-center widthFull ">

        </p>
      </div>

      <div class="col-md-12 center mb-0 vaillantCont text-left">

        <h4 class="Regular text-center h0 widthFull "><b> Per procedere con la tua pratica scegli il riquadro che è idoneo alla tua documentazione</b></h4>

      </div>

      <div class="col-md-6 center mb-3 vaillantCont text-center pt-5 pb-5">


        <button v-on:click="changeDL('old')" class="btn btn-primary">
          <h5 class="white">

            Confermo che:
            <br/>- Copia di cortesia o Fattura trasmessa al Sistema di Interscambio (Sdi) dal professionista
            aderente {{brand}} verso il proprio cliente (committente) con Data Documento <b class="black Bold uppercase"> entro </b> l’11
            novembre 2021 (incluso)
            <br/>− Data di esecuzione del Bonifico Bancario (parlante) disposto dal cliente (committente)
            <b class="black Bold uppercase"> entro </b>, l’11 novembre 2021 (incluso), in riferimento alla relativa fattura rilasciata dal
            professionista aderente CheBonus
            <br/>

          </h5>
        </button>

      </div>

      <div class="col-md-6 center mb-3 vaillantCont text-left pt-5 pb-5">
        <button v-on:click="changeDL('new')" class="btn btn-primary">
        <h5 class="white">
          Confermo che:
          <br/>- Copia di cortesia o Fattura trasmessa al Sistema di Interscambio (Sdi) dal professionista
          aderente {{brand}} verso il proprio cliente (committente) con Data Documento <b class="black Bold uppercase"> oltre </b> l’11
          novembre 2021 (incluso)
          <br/>− Data di esecuzione del Bonifico Bancario (parlante) disposto dal cliente (committente)
          <b class="black Bold uppercase"> oltre </b>, l’11 novembre 2021 (incluso) in riferimento alla relativa fattura rilasciata dal
          professionista aderente CheBonus
          <br/>
        </h5>
        </button>
      </div>

    </div>

  </div>

  <!--  CHECK DL - PAID YET AND PAY DIFERENZE ******************************************************************************************************************** -->
  <div v-else-if="item.dl == '0' && item.status == '1' && item.payment_id != 0 && item.payment_id != '0' && item.aditional_payment == 0" class="container mb-5 pb-5">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <div class="col-md-12  text-left">
        <h3 class="Regular h0 widthFull"><b>Pratica N. {{item.code}} </b></h3>
      </div>

      <div class="col-md-12 center mb-3 text-center">
        <h4 class="Regular text-center h0 widthFull "><b>Avvertenza per Decreto Legge dell’11 Novembre 2021 n. 157 relativo al contrasto alle frodi  </b></h4>
        <p class="black mt-0 text-center widthFull ">

        </p>
      </div>

    </div>
    <!--   SWITCH ALD/NEW    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div v-if="!additionalPayment" class="row justify-content-center text-left">

      <div  class="col-md-5 center mb-0 vaillantCont text-center pb-5">
        <!--
        <h4 class="Regular text-center h0 widthFull "><b> Per procedere con la tua pratica scegli il riquadro che è idoneo alla tua documentazione</b></h4>
      -->
        <h4 class="Regular text-center h0 widthFull mt-5 "><b>
        Per completare la tua pratica a norma del D.L 157, bisogna integrare il visto di conformità
          <span v-if="item.flow == 'poste'"> e la Due Diligence. </span>
          </b></h4>

          <button v-on:click="additionalPayment = true" class="btn btn-primary mt-5 mb-5">

            Avanti

          </button>

      </div>
      <!--
      <div class="col-md-6 center mb-3 vaillantCont text-center pt-5 pb-5">

        <button v-on:click="changeDL('old')" class="btn btn-primary">
          <h5 class="white">
            Confermo che:
            <br/>- Copia di cortesia o Fattura trasmessa al Sistema di Interscambio (Sdi) dal professionista
            aderente {{brand}} verso il proprio cliente (committente) con Data Documento <b class="black Bold uppercase"> entro </b> l’11
            novembre 2021 (incluso)
            <br/>− Data di esecuzione del Bonifico Bancario (parlante) disposto dal cliente (committente)
            <b class="black Bold uppercase"> entro </b>, l’11 novembre 2021 (incluso), in riferimento alla relativa fattura rilasciata dal
            professionista aderente CheBonus
            <br/>
          </h5>
        </button>

      </div>

      <div class="col-md-3 center mb-3 vaillantCont text-left pt-5 pb-5">

      </div>-->

    </div>
    <!--   PAY DIFERENCE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div v-else class="row justify-content-center text-left">

      <div  class="col-md-12 center mb-0 vaillantCont text-left">

        <h4 class="Regular text-center h0 widthFull uppercase"><b> Integrazione </b></h4>

      </div>

      <div  class="col-md-12 center mb-0 vaillantCont text-left">

        <!--   HEADER TITLE ADITIONAL PAYMENT    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        <div v-if="!paySuccess" class="row justify-content-center text-left">

          <div class="col-md-8 center mb-3 text-left">
            <h4 class="Regular text-left h0 widthFull "><b> Per completare la tua pratica a norma del D.L 157, bisogna integrare il visto di conformità
              <span v-if="item.flow == 'poste'"> e la Due Diligence. </span>
               Acquista  <span v-if="item.flow == 'poste'">i servizi </span> <span v-else>il servizio </span> con una Carta, PayPal o Bonifico Bancario (SOFORT)

            </b></h4>
            <p class="black mt-0 text-left widthFull ">
              Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.
            </p>
          </div>
          <div class="col-md-4 pt-md-4 center mb-3 text-right">
            <a v-on:click="additionalPayment = false" class="btn btn-primary btnRed m-2 btn-sm ml-md-5 white">
              <font-awesome-icon icon="arrow-left" size="1x" />
              Indietro
            </a>
          </div>

        </div>


          <!--    ADITIONAL PAYMENT    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        <div class="row justify-content-center text-left">
          <div class="col-md-12 pb-0 buyPlan center">
            <h3 class="center darkBlue mb-3"> </b></h3>
            <div class="widthFull" v-if="!paySuccess">
              <div class="row ">

                <div class="col-sm-6 col-md-6 col-lg-6 text-left bgWhite">

                  <div class="row ">
                    <div class="col-md-8 text-left">
                      <h5 class=" text-left mb-0"> Costo aggiuntivo <span v-if="item.flow == 'poste'"> di Due Diligence </span> Servizio/Pratica (IVA Esclusa) </h5>
                    </div>
                    <div class="col-md-3 text-right">
                      <h5 class=" text-right mb-0"><b class="">{{buyPlan2.price | formatNumber}} € </b></h5>
                    </div>
                  </div>

                  <div  class="row ">
                    <div class="col-md-8 text-left">
                      <h5 class=" text-left mb-0"> Visto di conformità (IVA Esclusa) </h5>
                    </div>
                    <div class="col-md-3 text-right">
                      <h5 class=" text-right mb-0"><b class="">{{buyPlan2.visto | formatNumber}} € </b></h5>
                    </div>
                  </div>

                  <div v-if="discountValue" class="row ">
                    <div class="col-md-8 text-left">
                      <h5 class=" text-left mb-0 red"> Sconto </h5>
                    </div>
                    <div class="col-md-3 text-right">
                      <h5 class=" text-right mb-0 red"><b class="">- {{discountValue | formatNumber}} € </b></h5>
                    </div>
                  </div>

                  <div class="row ">
                    <div class="col-md-8 text-left">
                      <h5 class=" text-left mb-4"> IVA 22% </h5>
                    </div>
                    <div class="col-md-3 text-right">
                      <h5 class=" text-right mb-4"> <b class="">{{buyPlan2.iva | formatNumber}} € </b></h5>
                    </div>
                  </div>


                  <div class="row ">
                    <div class="col-md-8 borderTopBlack text-left">
                      <h5 class=" text-right mb-4">
                        TOTALE (IVA inclusa)
                      </h5>
                    </div>

                    <div class="col-md-3 text-right borderTopBlack">
                      <h5 class=" text-right mb-4">
                        <!-- PAY ADDITIONAL -->
                        <b class="">{{buyPlan2.amount | formatNumber}} € </b>

                      </h5>

                    </div>

                  </div>

                </div>
                <div class="col-sm-0 col-md-1 col-lg-1 text-left"></div>
                <div class="col-sm-6 col-md-6 col-lg-4">

                  <h2 v-if="paypalOn" class="center widthFull mb-3 mt-3 bgWhite pb-3">
                    <h3 class="center  mb-3 mt-0 pt-0"><b>Paga con</b></h3>

                    <!-- CLASSIC -->
                    <paypalPayment @paymentPPSuccess="paymentPPSuccess" :amount="'' + buyPlan2.amount" :invoice-number="brand + '_DL_PRATICA_' + item.code + paypalDiscountString"
                      :items="[{'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan2.amount, 'quantity': '1', 'currency': 'EUR'}]" currency="EUR" locale="it_IT"
                      :experience="experienceOptions" :practice="item.code" :dl="item.dl" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn">
                    </paypalPayment>

                    <!-- CLASSIC
                    <paypal-checkout  :env="envPP" :amount="'' + buyPlan2.amount" :invoice-number="brand + '_DL_PRATICA_' + item.code + paypalDiscountString"
                      :items="[{'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan2.amount, 'quantity': '1', 'currency': 'EUR'}]" currency="EUR" locale="it_IT" :client="credentials" :button-style="{size:'large'}"
                      :experience="experienceOptions" v-on:payment-authorized="paymentAuthorized" v-on:payment-completed="paymentCompleted" v-on:payment-cancelled="paymentCancelled">
                    </paypal-checkout>

                    <div v-if="autoReNew && !loadButtons" id="paypal-button-container"></div>-->

                  </h2>

                  <!-- CLASSIC
                  <h2 class="center widthFull mb-3 mt-3 bgWhite">

                    <stripePayment :items="[{'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan2.amount, 'quantity': '1', 'currency': 'EUR'}]"
                      :invoiceNumber="brand + '_DL_PRATICA_' + item.code" :amount="'' + buyPlan2.amount" :practice="item.code" :dl="'aditional'" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn" :discount="discount" :discountValue="discountValue" />

                  </h2>-->
                  <!--
                  <p v-if="loadButtons" class="center mt-4">
                    <img class="img-fluid smallLoading" src="../../assets/images/load2.gif">
                  </p>
                -->
                </div>
              </div>
            </div>
            <div v-if="paySuccess" class="col-sm-12 center pb-5">
              <img class="img-fluid payImage" src="../../assets/images/success.png">
              <br />
              <h1 class="center">Grazie per averci scelto, </h1>
              <h3 class="center">il tuo pagamento è avvenuto con successo</h3>

              <button class="btn btn-primary rn-btn-dark btnRed mt-5" v-on:click="payment = true; item.aditional_payment = 1">
                <span class="hover hover-1">Procedi</span>
              </button>

            </div>
          </div>


        </div>



      </div>

    </div>

  </div>

  <!--  PAYMENT KO ******************************************************************************************************************** -->
  <div v-else-if="!payment && loaded" class="container mb-5 pb-5">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <h3 class="Regular text-left h0 widthFull"><b>Pratica N. {{item.code}} </b></h3>

      <div class="col-md-8 center mb-3 text-left">
        <h4 class="Regular text-left h0 widthFull "><b> Per completare la tua pratica, paga il servizio con una Carta, PayPal o Bonifico Bancario (SOFORT) </b></h4>
        <p class="black mt-0 text-left widthFull ">
          Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.
        </p>
      </div>
      <div class="col-md-4 pt-md-4 center mb-3 text-right">
        <router-link :to="{ name: 'pratiche'}" class="btn btn-primary btnRed m-2 btn-sm ml-md-5">
          <font-awesome-icon icon="arrow-left" size="1x" />
          Indietro
        </router-link>
      </div>

    </div>


    <div class="row justify-content-center text-left">
      <div class="col-md-12 pb-0 buyPlan center">
        <h3 class="center darkBlue mb-3"> </b></h3>
        <div class="widthFull" v-if="!paySuccess">
          <div class="row ">

            <div class="col-sm-6 col-md-6 col-lg-6 text-left bgWhite">
              <div class="row ">
                <!-- SCONTO -->
                <div class="col-md-12 text-left customAccordion mb-3">
                  <badger-accordion :icons="icons" key="1232323" class="">
                    <badger-accordion-item>
                      <template slot="header" class="center">
                        <h4 class="Bold">
                          <font-awesome-icon icon="gift" size="md" class="mr-2" /> Hai un codice sconto ?
                        </h4>
                        <p class="black mt-0 text-left widthFull ">
                          Se possiedi un codice sconto, potrai utilizzarlo per il pagamento
                        </p>
                      </template>
                      <template slot="content" class="bbaLightColor">
                        <div v-if="discountError" class="widthFull Bold text-center red">
                          Codice sconto non valido
                        </div>
                        <form class="widthFull" id="discount-form" @submit.prevent="checkDiscount">
                          <div class="form-row justify-content-center">
                            <div class="col-md-8 mb-1">
                              <div class="group custInput">
                                <input type="text" v-model="discount" v-validate="{required:true, max: 26, min: 5}" class="form-control" id="discount" name="discount" data-vv-as="Codice sconto"
                                  :class="{ 'is-invalid': errors.has('discount'), valid: !!discount }">
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label class="niceInputLabel" for="discount">Codice Sconto</label>
                                <div v-if="errors.has('discount')" class="invalid-feedback">
                                  {{ errors.first("discount") }}
                                </div>

                              </div>
                            </div>
                            <div class="col-md-4 mb-1 pt-3 text-center">
                              <button class="btn btn-primary btn-sm btnYellow shadow mb-4 mt-4" type="submit">Applica</button>
                            </div>
                          </div>
                        </form>
                      </template>
                    </badger-accordion-item>

                  </badger-accordion>



                </div>
              </div>

              <div class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-0"> Prezzo Servizio/Pratica (IVA Esclusa) </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0"><b class="">{{buyPlan.price | formatNumber}} € </b></h5>
                </div>
              </div>

              <div v-if="item.dl  == 'new'" class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-0"> Visto conformità (IVA Esclusa) </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0"><b class="">{{buyPlan.visto | formatNumber}} € </b></h5>
                </div>
              </div>

              <div v-if="discountValue" class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-0 red"> Sconto </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0 red"><b class="">- {{discountValue | formatNumber}} € </b></h5>
                </div>
              </div>

              <div class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-4"> IVA 22% </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-4"> <b class="">{{buyPlan.iva | formatNumber}} € </b></h5>
                </div>
              </div>

              <!-- PRATICA ENEA -->
              <div v-if="item.enea_request  != '0'" class="row ">
                <div class="col-md-8 text-left borderTopBlack">
                  <h5 class=" text-left mb-0">Prezzo Servizio di redazione e invio pratica ENEA (IVA Esclusa) </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0"><b class="">{{buyPlan.priceEnea | formatNumber}} € </b></h5>
                </div>
              </div>

              <div v-if="item.enea_request  != '0' " class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-4"> IVA 22% </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-4"> <b class="">{{buyPlan.ivaEnea | formatNumber}} € </b></h5>
                </div>
              </div>

              <!-- DATI CATASTALI -->
              <div v-if="item.to_get_cadastral_data != '0' " class="row ">
                <div class="col-md-8 text-left borderTopBlack">
                  <h5 class=" text-left mb-0"> Prezzo Servizio "Visura Catastale" (IVA Esclusa) </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0"><b class="">{{buyPlan.priceDcast | formatNumber}} € </b></h5>
                </div>
              </div>

              <div v-if="item.to_get_cadastral_data  != '0' " class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-4"> IVA 22% </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-4"> <b class="">{{buyPlan.ivaDcast | formatNumber}} € </b></h5>
                </div>
              </div>


              <div class="row ">
                <div class="col-md-8 borderTopBlack text-left">
                  <h5 class=" text-right mb-4">
                    TOTALE (IVA inclusa)
                  </h5>
                </div>

                <div class="col-md-3 text-right borderTopBlack">
                  <h5 class=" text-right mb-4">
                    <!-- CLASSIC -->
                    <b class="" v-if="item.enea_request == '0' && item.to_get_cadastral_data == '0'">{{buyPlan.amount | formatNumber}} € </b>
                    <!-- CLASSIC + ENEA -->
                    <b class="" v-if="item.enea_request != '0' && item.to_get_cadastral_data == '0'">{{buyPlan.amount_enea | formatNumber}} € </b>
                    <!-- CLASSIC + DCAST -->
                    <b class="" v-if="item.enea_request == '0' && item.to_get_cadastral_data != '0'">{{buyPlan.amount_dcast | formatNumber}} € </b>
                    <!-- CLASSIC + ENEA + DCAST -->
                    <b class="" v-if="item.enea_request != '0' && item.to_get_cadastral_data != '0'">{{buyPlan.amount_enea_dcast | formatNumber}} € </b>

                  </h5>

                </div>

              </div>

            </div>
            <div class="col-sm-0 col-md-1 col-lg-1 text-left"></div>
            <div class="col-sm-6 col-md-6 col-lg-4">

              <h2 v-if="paypalOn" class="center widthFull mb-3 mt-0 bgWhite pb-3">
                <h3 class="center  mb-3 mt-0 pt-3"><b>Paga con</b></h3>

                <!-- CLASSIC -->
                <paypalPayment @paymentPPSuccess="paymentPPSuccess" v-if="item.enea_request == '0' && item.to_get_cadastral_data == '0'" :amount="'' + buyPlan.amount" :invoice-number="brand + '_PRATICA_' + item.code + paypalDiscountString"
                  :items="[{'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'}]" currency="EUR" locale="it_IT"
                  :experience="experienceOptions" :practice="item.code" :dl="item.dl" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn">
                </paypalPayment>

                <!-- CLASSIC + ENEA -->
                <paypalPayment @paymentPPSuccess="paymentPPSuccess" v-if="item.enea_request != '0' && item.to_get_cadastral_data == '0'"  :amount="'' + buyPlan.amount_enea" :invoice-number="brand + '_PRATICA_' + item.code + paypalDiscountString" :items="[
                {'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'}]" currency="EUR" locale="it_IT"
                  :experience="experienceOptions" :practice="item.code" :dl="item.dl" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn">
                </paypalPayment>

                <!-- CLASSIC + DCAST -->
                <paypalPayment @paymentPPSuccess="paymentPPSuccess" v-if="item.enea_request == '0' && item.to_get_cadastral_data != '0'"  :amount="'' + buyPlan.amount_dcast" :invoice-number="brand + '_PRATICA_' + item.code + paypalDiscountString" :items="[
                {'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]" currency="EUR" locale="it_IT"
                  :experience="experienceOptions" :practice="item.code" :dl="item.dl" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn">
                </paypalPayment>

                <!-- CLASSIC + ENEA + DCAST -->
                <paypalPayment @paymentPPSuccess="paymentPPSuccess" v-if="item.enea_request != '0' && item.to_get_cadastral_data != '0'"  :amount="'' + buyPlan.amount_enea_dcast" :invoice-number="brand + '_PRATICA_' + item.code + paypalDiscountString" :items="[
                {'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]" currency="EUR" locale="it_IT"
                  :experience="experienceOptions" :practice="item.code" :dl="item.dl" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn">
                </paypalPayment>


                <div v-if="autoReNew && !loadButtons" id="paypal-button-container"></div>

              </h2>


              <h2 v-if="2==3" class="center widthFull mb-3 mt-3 bgWhite">
                <!-- CLASSIC -->
                <stripePayment v-if="item.enea_request == '0' && item.to_get_cadastral_data == '0'" :items="[{'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'}]"
                  :invoiceNumber="brand + '_PRATICA_' + item.code" :amount="'' + buyPlan.amount" :practice="item.code" :dl="item.dl" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn" :discount="discount" :discountValue="discountValue" />

                <!-- CLASSIC + ENEA -->
                <stripePayment v-if="item.enea_request != '0' && item.to_get_cadastral_data == '0'" :items="[
                  {'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'}]" :amount="'' + buyPlan.amount_enea"
                  :invoiceNumber="brand + '_PRATICA_' + item.code" :practice="item.code" :dl="item.dl" :flow="item.flow" :userToken="getProfile.userToken" :PaypalOn="paypalOn" :sepaOn="sepaOn" :discount="discount" :discountValue="discountValue" />

                <!-- CLASSIC + DCAST -->
                <stripePayment v-if="item.enea_request == '0' && item.to_get_cadastral_data != '0'" :amount="'' + buyPlan.amount_dcast" :items="[
                  {'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]" :invoiceNumber="brand + '_PRATICA_' + item.code" :practice="item.code"
                  :userToken="getProfile.userToken" :PaypalOn="paypalOn" :dl="item.dl" :flow="item.flow" :sepaOn="sepaOn" :discount="discount" :discountValue="discountValue" />

                <!-- CLASSIC + ENEA + DCAST -->
                <stripePayment v-if="item.enea_request != '0' && item.to_get_cadastral_data != '0'" :amount="'' + buyPlan.amount_enea_dcast" :invoice-number="brand + '_PRATICA_' + item.code" :items="[
                  {'name': brand + '-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]" :invoiceNumber="brand + '_PRATICA_' + item.code" :practice="item.code"
                  :userToken="getProfile.userToken" :PaypalOn="paypalOn" :dl="item.dl" :flow="item.flow" :sepaOn="sepaOn" :discount="discount" :discountValue="discountValue" />

              </h2>
              <!--
              <p v-if="loadButtons" class="center mt-4">
                <img class="img-fluid smallLoading" src="../../assets/images/load2.gif">
              </p>
            -->
            </div>
          </div>
        </div>
        <div v-if="paySuccess" class="col-sm-12 center">
          <img class="img-fluid payImage" src="../../assets/images/success.png">
          <br />
          <h1 class="center">Grazie per averci scelto, </h1>
          <h3 class="center">il tuo pagamento è avvenuto con successo</h3>

          <button class="btn btn-primary rn-btn-dark btnRed mt-5" v-on:click="payment = true">
            <span class="hover hover-1">Procedi</span>
          </button>

        </div>
      </div>


    </div>

  </div>

  <!--  PAYMENT OK ******************************************************************************************************************** -->
  <div v-else-if="payment && loaded" class="container  mb-5 pb-5 pt-2">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <div class="col-md-12  text-left">
        <h3 class="Regular h0 widthFull"><b>Pratica N. {{item.code}} </b></h3>
      </div>

      <div class="col-md-8 center mb-3 text-left">

        <h4 class="Regular text-left h0 widthFull "><b> Gestione Documenti </b></h4>
        <p class="black mt-0 text-left widthFull ">
          Prepara e carica tutti i documenti richiesti. Al termine dell caricamento ogni singolo documento clicca su pulsante CONCLUDI.
        </p>

        <p class="black mt-0 text-left widthFull ">
          <font-awesome-icon class="mr-2" icon="star-of-life" size="" /> <b>Documenti Obbligatori</b>
        </p>
      </div>

      <div class="col-md-4 pt-md-4 center mb-3 text-right">
        <router-link :to="{ name: 'pratiche'}" class="btn btn-primary btnRed m-2 btn-sm ml-md-5">
          <font-awesome-icon icon="arrow-left" size="1x" />
          Indietro
        </router-link>
      </div>

    </div>

    <form class="pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont" id="doc-form">

      <div  class="row  pt-2 mb-3" style="border-bottom: 1px solid grey;  padding-bottom: 0!important;">

          <div  class="col-12 col-md-1 bordered text-center tablePdMob">
              <small>Stato </small>
          </div>

          <div class="col-12 col-md-5 bordered text-center text-md-center">
            <h5 class="widthFull black mt-0 pt-0 docTitleMob pl-md-3">
              <font-awesome-icon class="mandatoryDoc" style="opacity: 0" icon="star-of-life" size="xs" />
              <small>Documento</small>
            </h5>
          </div>


          <div class="col-12 col-md-1 text-center bordered tablePdMob">
            <small>Informazioni</small>
          </div>

          <div  class="col-12 col-md-3 center bordered tablePdMob">
            <small>Carica/modifica Documento
              <br/>(solo formati: JPG,PNG,PDF)
            </small>
          </div>

          <div class="col-12 col-md-1 text-center bordered tablePdMob">
            <small>File Documento</small>
          </div>

          <div class="col-21 col-md-1 center bordered tablePdMob">
            Caricamento Concluso
          </div>

      </div>

      <div v-for="(doc,index,k) in documents"
        v-if=" ( doc.codice != '2050D11' || item.dcast_export == '10' && doc.codice == '2050D11' || item.to_get_cadastral_data == '0' && doc.codice == '2050D11' ) && ( doc.codice != '2050D15' || item.enea_pdf && doc.codice == '2050D15' || item.enea_request == '0' && doc.codice == '2050D15' ) "
        class="row justify-content-center vaillantCont pt-2 pb-2" :class="{'pt-0': k == 0, 'even': String(k / 2).includes('.') }">
        <div class="col-12 col-md-1 bordered center tablePdMob">

          <template v-if="doc.mandatory == 'no' && doc.codice == '2050D0B' ">
            <img v-if="!uploadFrontPercentage[index]['countImages'] || uploadFrontPercentage[index]['hasError'] == 'yes'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_green.png">
          </template>
          <template v-else>
            <img v-if="!uploadFrontPercentage[index]['countImages'] || uploadFrontPercentage[index]['hasError'] == 'yes'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_red.png">
          </template>
          <img v-if="uploadFrontPercentage[index]['countImages'] && !uploadFrontPercentage[index]['completed'] && uploadFrontPercentage[index]['hasError'] == 'no'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_yellow.png">
          <img v-if="uploadFrontPercentage[index]['completed'] && uploadFrontPercentage[index]['hasError'] == 'no'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_green.png">

        </div>

        <div class="col-12 col-md-5 bordered text-center text-md-left">

          <h5 class="widthFull black mt-0 pt-0 docTitleMob pl-md-3">
            <font-awesome-icon v-if="doc.mandatory == 'yes'" class="mandatoryDoc" icon="star-of-life" size="xs" />
            <template v-if="item.flow == 'agileenergy' && doc.codice == '2050D06E'"> Contratto per la fornitura e l’installazione accettato e firmato dal cliente </template>
            <template v-if="item.flow == 'agileenergy' && doc.codice == '2050D07A'"> Evidenze di pagamento da parte del Cliente Finale (bonifico ordinario)</template>
            <template v-else> {{doc.name}} </template>

            <span v-if=" doc.codice == '2050D01' || doc.codice == '2050D02' || doc.codice == '2050D03' ">
             <br/><small> <b>Per le Pratiche con “data fattura” antecedente al 4 aprile potrà essere caricato un documento “blank” vuoto.</b> </small>
            </span>


            <span v-if="uploadFrontPercentage[index]['hasError'] == 'yes'" class="widthFull red mt-0 pt-0 docTitleMob pl-md-3">
              Rilevata la seguente anomalia: <br />{{ uploadFrontPercentage[index]['error'] }}
            </span>
          </h5>


          <div v-if="errors.has('fileInput' + index)" class="invalid-feedback-custom">
            {{ errors.first('fileInput' + index) }}
          </div>

          <div v-if="uploadFrontPercentage[index]['percent']" class="progress" id="progFront">
            <div class="progress-bar" id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage[index]['percent'] + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
              {{ uploadFrontPercentage[index]['percent'] }} %
            </div>
          </div>

        </div>

        <div class="col-6 col-md-2 text-right bordered  tablePdMob" :class="{'d-none d-md-block': doc.template == 'no', 'd-block d-md-block': doc.template == 'yes'}">

          <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( doc.codice == '2050D20' ) " :href="doc.template_link" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">linee guida</a>

          <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( doc.codice != '2050D0B' ) && ( doc.codice != '2050D20' ) " :href="doc.template_link" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Modulo</a>

          <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( doc.codice != '2050D0B' ) && ( doc.codice != '2050D20' ) " v-on:click="precompileDocument( doc.codice, getProfile, item )" class="btn btn-primary btn-xl mt-3 mt-md-0 white" type="button">PRECOMPILATO</a>
          <!-- doc.codice == '2050D14' || doc.codice == '2050D16' || doc.codice == '2050D19' || doc.codice == '2050D112' || doc.codice == '2050D111' 2050D13A -->
          <!-- TO CHANGE DOC -->
          <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( ( getProfile.tipo_azienda != 'Ditta Individuale' && getProfile.tipo_azienda != 'Professionista iscritto ad albi' ) && doc.codice == '2050D0B' ) "
            :href="doc.template_link" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Istruzioni</a>

          <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( ( getProfile.tipo_azienda == 'Ditta Individuale' || getProfile.tipo_azienda == 'Professionista iscritto ad albi' ) && doc.codice == '2050D0B' ) "
            href="https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Istruzioni</a>

        </div>


        <div :class="{'col-12 center': doc.template == 'no', 'col-6': doc.template == 'yes'}" class=" col-md-1 bordered tablePdMob">

          <div v-if="( !uploadFrontPercentage[index]['completed']  && item.status == 1 && uploadFrontPercentage[index]['hasError'] == 'no' ) " class="front-image2">

            <input type="file" v-on:change="uploadFile(index,item.code,doc.name,doc.codice)" :ref="'fileInput' + index" :name="'fileInput' + index" :id="'fileInput' + index" class="btn btn-primary btn-xl btnRed" :data-vv-as="doc.name"
              v-validate="{required: doc.mandatory == 'yes',size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
              :class="{ 'is-invalid': errors.has('fileInput' + index), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">
            <span class="highlight"></span>
            <span class="bar"></span>

            <label class="niceInputLabel2 labelFileInput" for="invoiceFront">
              <span class="smallText center white">
              </span>
            </label>

            <!--
            <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>
          -->
          </div>

          <router-link v-else-if="( uploadFrontPercentage[index]['completed'] && item.status == 1 && item.hasErrors == 'no') || ( item.status == 1 && uploadFrontPercentage[index]['hasError'] == 'yes' )" class="btn btn-primary btn-xl"
            :to="{ name: 'editDocument', params: {doc: doc, dbdoc: uploadFrontPercentage[index], item: item, docIndex: index }}">
            Modifica
          </router-link>

        </div>


        <div class="col-4 col-md-1 bordered tablePdMob">

          <button v-if="uploadFrontPercentage[index]['countImages']" class="btn btn-primary btn-xl" v-on:click="show(index)" type="button">Visualizza</button>

          <!-- @inited="inited" -->
          <viewer class="imagesViewer clearfix widthFull" :ref="'viewer' + index">
            <template v-for="(image, key) in uploadFrontPercentage[index]['images']">
              <img v-if="image.substring(image.lastIndexOf('.')+1, image.length).toLowerCase() != 'pdf'" :src="image" :key="key" class="img-fluid">
              <a v-else :href="image" class="pdfViewer" target="_blank">
                <img src="../../assets/images/pdf.png" :key="key" class="img-fluid">
              </a>
            </template>
          </viewer>

        </div>
        <div class="col-4 col-md-1 text-center bordered tablePdMob">
          <template v-for="img in uploadFrontPercentage[index]['images']">

            <a class="docThumb" v-if="img.substring(img.lastIndexOf('.')+1, img.length).toLowerCase() != 'pdf'" :href="img" target="_blank">
              <font-awesome-icon icon="file-alt" />
            </a>
            <a class="docThumb relative" v-else :href="img" target="_blank">
              <font-awesome-icon icon="file-pdf" class="" /> <small class="littlePdf">PDF</small>
            </a>

          </template>

        </div>

        <div class="col-4 col-md-1 center bordered tablePdMob">

          <button v-if="uploadFrontPercentage[index]['countImages'] && !uploadFrontPercentage[index]['completed']" class="btn btn-primary btn-green btn-xl" v-on:click="closeDocumentBlock(index,item.code,doc.name,doc.codice)"
            type="button">Concludi</button>
          <font-awesome-icon v-else-if="uploadFrontPercentage[index]['completed']" icon="check" />

        </div>

      </div>

      <div v-if="( ( item.dl != 'old' && item.flow == 'poste' ) || item.flow == 'cdp' || item.flow == 'general' || item.flow == 'agileenergy' || item.flow == 'mbfacta' || item.flow == 'mbfacta_recovery'  ) && item.enea_request == '0' " class="row justify-content-center vaillantCont pt-2 pb-2" >
        <div class="col-md-12 bordered center tablePdMob">

            <div class="row justify-content-center  align-items-center">

              <div class="col-12 col-md-1 bordered center tablePdMob ">

                <template  v-if="item.enea_cpid">
                  <img v-if="item.enea_cpid" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_green.png">
                </template>
                <template v-else>
                  <img  class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_red.png">
                </template>

              </div>

              <div class="col-md-5 mb-3">
                <h5 class="widthFull black mt-0 pt-0 pb-0 mb-0 docTitleMob pl-md-3 text-left">
                  <font-awesome-icon v-if=" item.bonus != 'Bonus Casa 50%' " class="mandatoryDoc" icon="star-of-life" size="xs" />
                  Inserisci codice CPID della Pratica ENEA
                </h5>
              </div>

              <div class="col-md-5 mb-3 text-left">

                <div class="group pt-0 mt-0">
                  <input type="text" class="form-control pb-0 mb-0" :disabled=" item.enea_cpid " v-model="enea_cpid" id="enea_cpid" name="enea_cpid" data-vv-as="CPID" v-validate="{required: item.bonus != 'Bonus Casa 50%' ? true : false, max: 30, min: 28, regex: '[0-9]*[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][A-Z]-[A-Z]*'}"
                    :class="{ 'is-invalid': errors.has('enea_cpid'), valid: !!enea_cpid, 'disabled': item.enea_cpid }">
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="niceInputLabel " style="color: black !important; top: 0px; left: 5px;" for="name">CPID *</label>
                  <div v-if="errors.has('enea_cpid')" class="invalid-feedback">
                    {{ errors.first("enea_cpid") }}
                  </div>
                </div>

              </div>

              <div class="col-md-1 mb-3 text-center">
                <button v-if="!item.enea_cpid" class="btn btn-primary btn-green btn-xl" v-on:click="saveCpid()"
                  type="button">Concludi</button>
                <font-awesome-icon v-else-if="item.enea_cpid" icon="check" />
              </div>

            </div>



        </div>
      </div>


      <!-- ENEA DOCUMENTS REQUEST ************************************************************************* -->
      <div v-if=" ( item.aditional_enea_data == null || item.aditional_enea_data == '' ) && item.enea_request == '1' " class="col-md-12 center mb-4">
        <h5 class="Regular text-center h0 widthFull ">
          <b><span class="yellow">Attenzione!</span> Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni </b>
          <!-- <b v-else><span class="yellow">Attenzione!</span> Per redigere ed inviare la pratica ENEA avremo bisogno di ulteriori informazioni che ti chiederemo alla conclusione del Set Documentale. </b>
          -->
          <router-link :to="{ name: 'complateEneaData', params: {item: item} }" class="btn btn-primary m-2 btn-sm">
            Inserisci Dati
          </router-link>
        </h5>

      </div>
      <!-- END DOCUMENTS REQUEST ************************************************************************* -->


      <div v-if="item.status == 1" class="row justify-content-center">
        <div class="col-12 col-md-12 text-right">

          <button v-if="!preSend" class="btn btn-primary btnRed" type="button" v-on:click="preSendPracticeToKPMG()">Avanti</button>

          <button v-if="preSend" class="btn btn-primary btnRed" type="button" v-on:click="sendPracticeToKPMG()">Procedi</button>

          <div v-if="2==3" class="widthFull requiredCont p-4 mt-4 text-left">

            <b>Ti informiamo che è in programma un aggiornamento informatico da parte del nostro partner KPMG che migliorerà ulteriormente la tua esperienza utente sulla piattaforma</b>
            <b class="green" v-if="brand == 'CHEBONUS'">Vaillant CheBonus</b>
            <b class="red" v-else>Hermann Saunier Duval HappyBonus</b>
            <!--<a class="Bold underline black" href="https://vaillant.us10.list-manage.com/track/click?u=f113ead641649fb248e3faebb&id=79bcc56609&e=c067c33edc" target="_blank"> CheBonus</a>.
            -->
            <!--<br/>Per 48h/72h potresti incontrare alcune difficoltà durante l’elaborazione delle pratiche.-->

            <br />Ci scusiamo per l'eventuale disagio, con l'obiettivo di migliorare sempre di più la tua soddisfazione ed esperienza sulla piattaforma
            <b class="green" v-if="brand == 'CHEBONUS'">Vaillant CheBonus</b>
            <b class="red" v-else>Hermann Saunier Duval HappyBonus</b>
            <!--
            <a class="Bold underline black" href="https://vaillant.us10.list-manage.com/track/click?u=f113ead641649fb248e3faebb&id=79bcc56609&e=c067c33edc" target="_blank"> CheBonus</a>.
          -->
            <br />Per procedere all'inoltro delle pratiche ti suggeriamo di riprovare a partire dalle ore 18:00 del 08/11/2021.

          </div>

        </div>
      </div>

    </form>



  </div>



</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  USER_REQUEST,
  USER_SET_DEFAULT_SHIP_DATA
} from 'actions/user'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import 'viewerjs/dist/viewer.css'

import Vue from 'vue'

import stripePayment from './stripe.vue'
import paypalPayment from './paypal_nt.vue'

const moment = require('moment')

const viewer = require('v-viewer')

//import { StripeCheckout } from '@vue-stripe/vue-stripe'

import {
  BadgerAccordion,
  BadgerAccordionItem
} from 'vue-badger-accordion'

const rand = Math.floor(Math.random() * 10000)

// GET DOC LIST

//import documentsOR from '../../components/documents/documents.js'
//import documents_cdpOR from '../../components/documents/documents_cdp.js'

//import documentsOROld from '../../components/documents/documentsOld.js'
//import documents_cdpOROld from '../../components/documents/documents_cdpOld.js'

export default {
  name: 'loadDocuments',
  components: {
    //StripeCheckout
    BadgerAccordion,
    BadgerAccordionItem,
    stripePayment,
    paypalPayment
  },
  data() {
    return {
      brand: process.env.BRAND,
      token: '',
      preSend: false,
      icons: {
        opened: '<img class="img-fluid widthFull sssIcon" src="' + require("../../assets/images/close.png") + '" >',
        closed: '<img class="img-fluid widthFull sssIcon" src="' + require("../../assets/images/open.png") + '" >'
      },
      discount: '',
      enea_cpid: '',
      loadingState: false,
      loading: false,
      practices: {},
      moment: require('moment'),
      item: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      cellulare: '',
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: {},
      client_ownership: '',
      subalterno: '',
      particella: '',
      savedDocuments: {},
      foglio: '',
      documents: {}, //this.$route.params.item.flow == 'poste' ? documentsOR : documents_cdpOR,
      //documents: {},
      payment: false,
      paypalOn: true,
      sepaOn: false,
      paymentTypeD: '',
      paid: '',
      autoRenewD: '',
      priceIvaC: '',
      priceIvaA: '',
      priceIfYearSubIva: '',
      priceIva: '',

      //STRIPE
      pk: process.env.STRIPE_PUBLISHABLE_KEY,
      front_url: process.env.FRONT_END_URL,
      iva: process.env.IVA,
      practiceprice: ( this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP ) + ( process.env.PRACTIC_VISTO ),

      buyPlan: {
        price: (this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) ,
        iva: (this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) * 0.22 + ( process.env.PRACTIC_VISTO * 0.22 ),
        amount: ((this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) + ( process.env.PRACTIC_VISTO * 1.22 ) + (this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) * 0.22),
        amount_enea: parseFloat((this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) + ( process.env.PRACTIC_VISTO * 1.22 ) + ((this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) * 0.22) +
          50 * 1.22).toFixed(2),
        amount_dcast: parseFloat((this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) + ( process.env.PRACTIC_VISTO * 1.22 ) + ((this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) * 0.22) +
          10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat((this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) + ( process.env.PRACTIC_VISTO * 1.22 ) + ((this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP) *
          0.22) + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        visto: process.env.PRACTIC_VISTO,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2,
        discountValue: 0,
        discount: '',
      },
      buyPlan2: {
        price: (this.$route.params.item.flow == 'poste' ? 60 : 10) ,
        iva: (this.$route.params.item.flow == 'poste' ? 60 : 10) * 0.22 + ( process.env.PRACTIC_VISTO * 0.22 ),
        amount: ((this.$route.params.item.flow == 'poste' ? 60 : 10) + ( process.env.PRACTIC_VISTO * 1.22 ) + (this.$route.params.item.flow == 'poste' ? 60 : 10) * 0.22),
        visto: process.env.PRACTIC_VISTO,
        discountValue: 0,
        discount: '',
        type: 'additionalPayment'
      },
      billingType: false,
      autoReNew: false,
      envPP: '',
      credentials: {
        sandbox: process.env.PAYPAL_ID,
        production: process.env.PAYPAL_ID
      },
      experienceOptions: {
        input_fields: {
          no_shipping: 1
        }
      },
      paySuccess: false,
      PPAUTHTOKEN: false,
      loadButtons: false,
      loaded: false,
      concluded: false,
      discountError: false,
      discountValue: 0,
      paypalDiscountString: '',
      dl: 0,
      additionalPayment: false,
      paySuccess2: false,
    }

  },
  methods: {
    precompileDocument(doc,user,practice){
      var _vue = this
      _vue.loadingState = true
      var data = {
        document: doc,
        user: user,
        practice: practice
      }

      console.log(data)

      axios({
        url: process.env.ROOT_API + 'api/precompileDocumentTemplate',
        method: 'POST',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
          'Content-type': 'application/json'
        }
      })
      .then(resp => {
        _vue.loadingState = false
        console.log( resp.data.document )
        window.open(resp.data.document, '_blank').focus();

      })
      .catch(error => {

        _vue.loadingState = false
        this.showAlert()

      })

    },
    changeDL(val){
      var _vue = this
      console.log( val )
      _vue.loadingState = true
      var data = {
        code: _vue.item.code,
        user_token: _vue.item.user_token,
        dl: val,
      }

      axios({
        url: process.env.ROOT_API + 'api/changeDL',
        method: 'POST',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
          'Content-type': 'application/json'
        }
      })
      .then(resp => {
        _vue.dl = val
        _vue.item.dl = val
        _vue.loadingState = false

      })
      .catch(error => {

        _vue.loadingState = false
        this.showAlert()

      })

    },
    saveCpid(){
      if( this.enea_cpid ){
        var hasError = false
        var _vue = this
        for ( var x in this.$validator.errors.items ){
          if( this.$validator.errors.items[x] == "enea_cpid" ){
            hasError == true
          }
        }

        if( hasError ){
          this.$validator.validate().then(valid => {})
        }else{

          _vue.loadingState = true
          var data = {
            code: _vue.item.code,
            user_token: _vue.item.user_token,
            enea_cpid: this.enea_cpid,
          }

          axios({
            url: process.env.ROOT_API + 'api/savePracticeCpid',
            method: 'POST',
            data: data,
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {

            _vue.item.enea_cpid = this.enea_cpid
            _vue.loadingState = false

          })
          .catch(error => {

            _vue.loadingState = false
            this.showAlert()

          })
        }

      }else{
        this.$validator.validate().then(valid => {})
      }
    },
    async preSendPracticeToKPMG() {
      var _vue = this

      // SEARCH VISURA
      var hasVisura = false
      var hasEnea = false

      console.log('HAS VISURA')
      console.log(this.savedDocuments)

      for (var x in this.savedDocuments) {
        if (this.savedDocuments[x].codice == '2050D11') {
          hasVisura = true
        }
      }
      for (var x in this.savedDocuments) {
        if (this.savedDocuments[x].codice == '2050D15') {
          hasEnea = true
        }
      }

      console.log('hasVisura :' + hasVisura)
      if (((this.item.to_get_cadastral_data == '1' && hasVisura == true) || this.item.to_get_cadastral_data == '0') && ((this.item.enea_request == '1' && hasEnea == true) || this.item.enea_request == '0')) {

        this.$validator.validate().then(async valid => {
          var _vue = this
          this.concluded = true

          for (var p in _vue.uploadFrontPercentage) {
            if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
              this.concluded = false
            }
          }

          if (this.concluded) {
            this.$swal({
              type: 'warning',
              title: '<strong class="modalText white">Attenzione </strong>',
              html: '<h4 class=" white">Controlla di aver caricato correttamente tutti i documenti e che gli stessi siano ben visibili. La validazione della pratica dipende anche dalla completezza del set documentale e sarà verificata entro ' +
                await _vue.addWorkingDay(moment(), 5) + '. Clicca su procedi per inviare la pratica in verifica.</h4>',
              confirmButtonText: 'CHIUDI',
              confirmButtonColor: '#15267',
              onClose: () => {
                _vue.preSend = true
              }
            });
          }

        })

      } else {


        if( this.item.enea_request == '1' && this.item.aditional_enea_data == null || this.item.aditional_enea_data == '' ){
          this.$swal({
            type: 'warning',
            title: '<strong class="modalText white">Attenzione! </strong>',
            html: '<h4 class=" white">Per procedere, compila i dati per redigere e inviare la Pratica ENEA cliccando sul pulsate "Inserisci Dati"  ',
            confirmButtonText: 'CHIUDI',
            confirmButtonColor: '#15267',
          });
        }else{
          this.sendPracticeToKPMG()
        }

      }
    },
    addWorkingDay(date, days) {
      let daysToAdd = days
      const today = date;
      const nextWeekStart = today.clone().add(1, 'week').weekday(1);
      const weekEnd = today.clone().weekday(5);

      const daysTillWeekEnd = Math.max(0, weekEnd.diff(today, 'days'));
      if (daysTillWeekEnd >= daysToAdd) return today.clone().add(daysToAdd, 'days');

      daysToAdd = daysToAdd - daysTillWeekEnd - 1;

      return moment(nextWeekStart.add(Math.floor(daysToAdd / 5), 'week').add(daysToAdd % 5, 'days')).format('DD-MM-YYYY')
    },
    checkDiscount() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loadingState = true
          this.discountError = false
          axios({
              url: process.env.ROOT_API + 'api/checkDiscountCode',
              method: 'POST',
              data: {
                discount: this.discount,
                userToken: this.getProfile.userToken,
                user: this.getProfile,
                practice: this.$route.params.item
              },
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              this.loadingState = false
              var value = resp.data.value
              if (value) {
                this.discountValue = parseFloat(value.replace(',', '.')).toFixed(2)
                this.recalcPrices('discount')
              }

            })
            .catch(error => {
              this.loadingState = false
              this.discountError = true

            })

        }
      })
    },
    recalcPrices(val) {

      var practicPrice = 0
      var visto = 0

      // NEW DL
      if( this.item.dl == 'new' ){
        visto = process.env.PRACTIC_VISTO
      }else{
        visto = 0
      }

      //practicPrice = 160
      if (this.item.flow == 'poste') {
        if( this.item.dl == 'new' ){
          practicPrice = process.env.PRACTIC_PRICE
        }else{
          practicPrice = process.env.PRACTIC_PRICE_OLD
        }
      } else if (this.item.flow == 'cdp') {
        if( this.item.dl == 'new' ){
          practicPrice = process.env.PRACTIC_PRICE_CDP
        }else{
          practicPrice = process.env.PRACTIC_PRICE_CDP_OLD
        }

      } else if (this.item.flow == 'general') {

        if( this.item.dl == 'new' ){
          practicPrice = process.env.PRACTIC_PRICE_GENERAL
        }else{
          practicPrice = process.env.PRACTIC_PRICE_GENERAL_OLD
        }

      } else if (this.item.flow == 'agileenergy') {

        if( this.item.dl == 'new' ){
          practicPrice = process.env.PRACTIC_PRICE_AGILEENERGY
        }else{
          practicPrice = process.env.PRACTIC_PRICE_AGILEENERGY_OLD
        }

      } else if (this.item.flow == 'mbfacta') {

        if( this.item.dl == 'new' ){
          practicPrice = process.env.PRACTIC_PRICE_MBFACTA
        }else{
          practicPrice = process.env.PRACTIC_PRICE_MBFACTA_OLD
        }

      }else if (this.item.flow == 'mbfacta_recovery') {

        if( this.item.dl == 'new' ){
          practicPrice = process.env.PRACTIC_PRICE_MBFACTA_RECOVERY
        }else{
          practicPrice = process.env.PRACTIC_PRICE_MBFACTA_RECOVERY_OLD
        }

      }


      var price = parseFloat( practicPrice + ( visto )  - this.discountValue)
      console.log(price)

      if( val == 'discount' ){
        this.paypalDiscountString = '?discount=' + this.discount + '&discountValue=' + this.discountValue
        var discountValue = this.discountValue
        var discount = this.discount
      }else{
        var discountValue = 0
        var discount = ''
      }

      this.buyPlan = {
        price: practicPrice,
        iva: price * 0.22,
        amount: (price + price * 0.22),
        amount_enea: parseFloat(price + (price * 0.22) + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(price + (price * 0.22) + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(price + (price * 0.22) + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        visto: visto,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2,
        discountValue: discountValue,
        discount: discount,
      }

    },
    submit() {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
    sendPracticeToKPMG: function() {

      console.log( this )

      this.$validator.validate().then(async valid => {

        var _vue = this
        this.concluded = true
        for (var p in _vue.uploadFrontPercentage) {
          if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
            this.concluded = false
          }
        }

        if (this.concluded && valid) {

          this.loadingState = true

          var data = {
            docs: this.uploadFrontPercentage,
            practice: this.item,
            user: this.getProfile
          }

          axios({
              url: process.env.ROOT_API + 'api/sendPracticeToKPMG',
              method: 'POST',
              data: data,
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              this.loadingState = false
              _vue.$router.push('/pratiche')
            })
            .catch(resp => {

              this.loadingState = false
              this.showAlert()

            })


        } else {
          this.showAlertNotConcluded()
        }


      })

    },
    paymentAuthorized: function(data) {
      //console.log(data);
    },
    paymentPPSuccess: async function(data) {
      var trans = data
      var _vue = this

      trans.intent = 'paypal_advanced_payment'
      trans.state = trans.purchase_units[0].payments.captures[0].status
      trans.payer.status = trans.payer.payer_id
      var payer_info = {
        email: trans.payer.email_address,
        first_name: trans.payer.name.given_name,
        last_name: trans.payer.name.surname,
        payer_id: trans.payer.payer_id,
        country_code: trans.payer.address.country_code ? trans.payer.address.country_code : 'X'
      }
      trans.payer.payer_info = payer_info

      var transactions = [
        {
          amount: {
            total: trans.purchase_units[0].payments.captures[0].amount.value,
            currency: trans.purchase_units[0].payments.captures[0].amount.currency_code
          }
        }
      ]

      trans.transactions = transactions

      await _vue.saveSubscription(trans)

      await _vue.forcereloadDocs()
      _vue.paySuccess = true


    },
    paymentCompleted: async function(data) {
      var trans = data
      var _vue = this
      if (trans.state == 'approved') {
        //console.error(trans)
        await _vue.saveSubscription(trans)

        await _vue.forcereloadDocs()
        _vue.paySuccess = true

      }
    },
    paymentCancelled: function(data) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Ci dispiace, </strong>',
        html: '<p>il pagamento non è andato a buon fine</p>',
        confirmButtonText: 'CHIUDI',
        confirmButtonColor: '#15267',
      });
    },
    getAuthToken: async function() {
      console.log('1) CREATE TOKEN')
      var _vue = this
      var urlencoded = new URLSearchParams();
      urlencoded.append("grant_type", "client_credentials");

      var envNow = ''
      if (process.env.PAYPAL_ENV == 'SANDBOX') {
        envNow = '.sandbox'
      }

      await axios({
          url: "https://api" + envNow + ".paypal.com/v1/oauth2/token",
          method: 'POST',
          data: urlencoded,
          auth: {
            username: process.env.PAYPAL_ID
            /*password: process.env.PAYPAL_SECRET*/
          },
          headers: {
            //'Authorization': 'Basic Basic QWVTNlpENmliWmNnVzJXUHFoX1ppVnBSQ09iWFlOdzJMUFAtTE1yTTIxNUFEYVhsWkRCeW5US0FPXy1uTDRJa3dycS1FQUY4TG9MZWRMNU06RU5Tc0kyaFg3OWVnSDFDS2ZETlBRbmYwU3NrYmNHdDByOUdSaVZEd05NQXJHejJIQU1QNmMzLTk2MGhwUWthMmdYb2I1R3pjRGJBVU5sZlk=',
            'Content-type': 'application/x-www-form-urlencoded'
          }
        })
        .then(resp => {
          //console.log(resp.data)
          _vue.PPAUTHTOKEN = resp.data.access_token
          console.log('1) SUCCESS')
          //console.warn(urlencoded)

          //_vue.test()

          _vue.createBillingPlan()
        })
        .catch(resp => {
          console.log(resp.response)
        })
    },
    saveSubscription: async function(trans) {
      var _vue = this
      const recaptcha = this.$recaptchaInstance
      // (optional) Wait until recaptcha has been loaded.
      await _vue.$recaptchaLoaded()
      // Execute reCAPTCHA with action "login".
      var token = await _vue.$recaptcha('login')

      this.paymentTypeD = 'Practice'

      _vue.buyPlan.paymentType = 'practice'
      _vue.buyPlan.expiredAt = moment().add(1, 'months').format("YYYY-MM-DD HH:mm:ss")

      if( _vue.item.payment_id != 0 && _vue.item.payment_id != '0' ){
        _vue.buyPlan2.paymentType = 'practice'
        _vue.buyPlan2.expiredAt = moment().add(1, 'months').format("YYYY-MM-DD HH:mm:ss")
      }


      this.autoRenewD = 'Disattivato'
      _vue.buyPlan.autoRenew = 'no'

      //console.error(trans)
      axios({
          url: process.env.ROOT_API + 'api/addPayment',
          method: 'POST',
          data: {
            token: token,
            userToken: _vue.getProfile.userToken,
            user: _vue.getProfile,
            subscription: (_vue.item.payment_id != 0 && _vue.item.payment_id != '0') ? _vue.buyPlan2 : _vue.buyPlan,
            transaction: trans,
            practice: this.item
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          console.log( 'SUBSCRIPTION SAVED' )
          if( ( _vue.item.payment_id != 0 && _vue.item.payment_id != '0' ) || _vue.dl == 0 ){
            if( _vue.item.bl == 0 ){
              _vue.dl = 'new'
              _vue.item.dl = 'new'
            }

            _vue.forcereloadDocs()
          }

        })
        .catch(resp => {
          //console.log(resp.response)
        })
        //await _vue.$recaptchaLoaded()
        //token = await _vue.$recaptcha('login')
    },
    inited(viewer) {
      var _vue = this
      this.$viewer = viewer
      console.log(viewer)

      console.log("ZOOOOOM")

      setTimeout(function() {
        _vue.$viewer.zoom(1)
      }, 1000)


    },
    show(index) {
      console.log(this)
      var el = this.$refs['viewer' + index]

      console.log(this.$refs)

      console.log(el[0])

      //const viewerV = el.$viewer

      el[0].destroyViewer()

      el[0].createViewer()

      el[0].$viewer.show()
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },
    convertToPractice: function() {
      var _vue = this
      console.log(this.$validator)
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loadingState = true
          // PREPARE
          var data = {}
          data.client_email = this.email
          data.client_codice_fiscale = this.codice_fiscale
          data.client_partita_iva = this.partita_iva
          data.client_phone = this.phone
          data.client_address = this.address
          data.client_civic = this.civic
          data.client_province = this.province
          data.client_city = this.city.city
          data.client_zip = this.zip
          data.client_ownership = this.ownership

          data.building_subalterno = this.subalterno
          data.building_particella = this.particella
          data.building_foglio = this.foglio
          data.practice_id = this.item.id
          data.user_token = this.getProfile.userToken
          data.signed_order = this.invoiceFrontBucket

          axios({
              url: process.env.ROOT_API + 'api/acceptOrder',
              method: 'POST',
              data: data,
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              console.log(resp)

              _vue.loadingState = false

              _vue.$swal({
                type: 'success',
                title: 'Pratica Inizializzata',
                html: 'Abbiamo creato la pratica <b>' + this.item.code +
                  '</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. ',
              });

              _vue.$router.push('/pratiche')

            })
            .catch(resp => {
              _vue.loadingState = false
              _vue.$swal({
                type: 'error',
                title: 'Oops...',
                text: 'Riprova piu tardi!',
              });
            })


        } else {
          console.log('ERROR IN FORM')
          _vue.$scrollTo('#' + _vue.errors.items[0].field, 700, {
            offset: -170
          })
        }
      })
    },
    populateProvincies: function() {
      const {
        provincies,
        provinciesState
      } = this
      axios({
          url: process.env.ROOT_API + 'api/getProvinciesAll',
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false

        })
        .catch(resp => {
          this.provincies = [];
          this.provinciesState = false
        })
    },
    checkProvince: function() {

      const {
        province
      } = this
      if (province) {
        this.cityError = false
      } else {
        this.cityError = true
      }

    },
    checkZip: function() {
      const {
        city
      } = this
      if (city) {
        this.zipError = false
      } else {
        this.zipError = true
      }
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ci dispiace! Riprova piu tardi',
      });
    },
    showAlertNotConcluded() {
      // Use sweetalret2
      this.$swal({
        type: 'warning',
        title: 'Attenzione!',
        text: 'Prima di procedere concludi il caricamento di tutti i documenti',
      });
    },
    async setCap(cap) {
      for (var x in this.zips) {
        if (this.zips[x].cap == cap.toUpperCase()) {
          this.zip = this.zips[x].cap
        }
      }

    },
    async setCity(city) {

      for (var x in this.cities) {
        if (this.cities[x].comune == city.toUpperCase()) {
          var k = {
            cityistat: this.cities[x].istat,
            city: city.toUpperCase(),
          }
          this.city = k
        }
      }
      console.log(this.city)

    },
    async setProvince(province) {

      for (var x in this.provincies) {
        console.log('START')
        console.log(this.provincies[x].sigla + ' =?= ' + province.toUpperCase())
        if (this.provincies[x].sigla == province.toUpperCase()) {
          this.province = this.provincies[x].sigla
        }
      }
      console.log(this.province)

    },
    closeDocumentBlock(doc, code, name, docCode) {
      var _vue = this
      var data = {}
      data.doc = doc
      data.code = code
      data.name = name
      data.docCode = docCode

      axios({
          url: process.env.ROOT_API + 'api/closeDocumentBlock',
          method: 'POST',
          data: {
            data: data
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {


          var r = this.uploadFrontPercentage[data.doc]
          r['completed'] = 1;
          //r['hasError'] = 'no'
          Vue.set(this.uploadFrontPercentage, data.doc, r)

          // NEW
          _vue.concluded = true
          for (var p in _vue.uploadFrontPercentage) {
            if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
              _vue.concluded = false
            }
          }

        })
        .catch(resp => {

        })

    },
    uploadFile(doc, code, name, docCode) {

      console.log(this.$refs['fileInput' + doc])
      var input = this.$refs['fileInput' + doc][0]

      console.log(input)

      console.log(doc)
      console.log(code)
      console.log(name)
      console.log(docCode)

      var ind = doc
      console.log(0)
      var file = input.files[0].name
      this.invoiceFrontName = file
      var extension = file.substr((file.lastIndexOf('.') + 1)).toLowerCase()
      var size = input.files[0].size
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.files[0].name
        var formData = new FormData();
        var _vue = this // << here
        formData.append('fattura0', input.files[0]);


        console.log(this.uploadFrontPercentage)

        formData.append('doc', doc);
        formData.append('code', code);
        formData.append('name', name);
        formData.append('docCode', docCode);

        console.log(1)

        axios.post(process.env.ROOT_API + 'api/uploadDocument',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              },
              onUploadProgress: function(progressEvent) {

                var r = this.uploadFrontPercentage[ind]

                r['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));

                //  Object.assign(this.uploadFrontPercentage, r)

                Vue.set(this.uploadFrontPercentage, ind, r)


                //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));

              }.bind(this)
            }
          ).then(function(e) {
            console.log(2)
            var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.document)) {
              _vue.uploadFrontPercentage[ind]['percent'] = 0

              var x = _vue.uploadFrontPercentage[ind]['images']

              x[e.data.id] = e.data.document

              _vue.uploadFrontPercentage[ind]['images'] = x
              _vue.uploadFrontPercentage[ind]['hasError'] = 'no'
              _vue.uploadFrontPercentage[ind]['countImages'] = 1
              _vue.uploadFrontPercentage[ind]['date'] = moment().format('YYYY-MM-DD HH:mm:00')

              console.log(_vue.uploadFrontPercentage)
              _vue.forcereloadDocs();
              //_vue.invoiceFrontBucket = e.data.fattura
            } else {
              _vue.uploadFrontPercentage[ind]['percent'] = 0
              //_vue.invoiceFront = ''
              //_vue.invoiceFrontBucket = ''
              _vue.forcereloadDocs();
              //input.value = null
            }

          })
          .catch(function() {
            _vue.uploadFrontPercentage.doc = 0
            //  _vue.invoiceFront = ''
            ///  _vue.invoiceFrontBucket = ''

            //input.value = null

          });
      }

    },
    async getDocuments(code, user_token) {

      await axios({
          url: process.env.ROOT_API + 'api/getDocumentsByCode',
          method: 'POST',
          data: {
            code: code,
            user_token: user_token
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.savedDocuments = resp.data.documents
        })
        .catch(resp => {
          this.savedDocuments = {}
        })
    },
    checkIfIban() {
      if (this.getProfile) {

        if (this.getProfile.iban == '') {

          this.$swal({
            type: 'warning',
            title: 'Attenzione!',
            text: 'Ricordati, che dovrai inserire l`Iban delle Poste Italiane prima della cessione del credito.',
          });

          //this.$router.push('/account')
        }

        // CHECK IF CAN PAY WITH SEPA NEWWWWWWWWWWWWWWW
        if (this.getProfile.iban_pay == '1') {
          console.log('OK SEPAZAAAAA')
          this.sepaOn = true
        }


      }
    },
    getDocumentsList: async function(flow, type, client){

      if( client == 'Persona fisica' ){
        var clientType = 'documents_physical_person'
      }else if( client == 'Partita IVA' ){
        var clientType = 'documents_legal_person'
      }else if( client == 'Amministratore di condominio' ){
        var clientType = 'documents_condominium'
      }

      var _vue = this
      console.warn('INSIDE getDocumentsList')
      var data = {
        flow: flow,
        type: type,
        clientType: clientType
      }
      //_vue.loadingState = true

      console.warn('DATA getDocumentsList', data)

      var x = await axios({
              url: process.env.ROOT_API + 'api/getDocumentsList',
              method: 'POST',
              data: data,
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {

              //_vue.loadingState = false
              if( resp.data.documents ){
                return resp.data.documents
              }else{
                return false
              }

            })
            .catch(resp => {
              _vue.$swal({
                type: 'error',
                title: 'Ops....',
                html: 'Riprova più tardi',
              });
              return false
              //_vue.loadingState = false
            })

        return x

    },
    async forcereloadDocs() {
      var _vue = this;

      console.warn(' INIT GET DOCS ')
      var docs = await this.getDocumentsList( this.$route.params.item.flow,  this.$route.params.item.dl == 'old' ? 'short' : 'full', this.$route.params.item.client_type )
      console.warn(docs)

      if (process.env.PAYPAL_ENV == 'SANDBOX') {
        _vue.envPP = 'sandbox'
      }

      //_vue.documents = docs
      var docTemp = docs
      _vue.documents = docs


      // ******************************************************************************************


      _vue.loadingState = true
      //_vue.uploadFrontPercentage = {}

      Object.assign(_vue.uploadFrontPercentage, {})

      var practice = _vue.$route.params.item

      await _vue.getDocuments(practice.code, 'asdg2352rsdfgv')

      for (var x in docs) {
        console.warn(x)
        if (practice.bonus == 'Bonus Casa 50%' && docs[x]['codice'] == '2050D19' && practice.client_type != 'Amministratore di condominio') {
          console.warn('Delete 2050D19')
          delete docs[x]
        }else if( ( docs[x]['codice'] == '2050D111' && practice.to_get_cadastral_data == '0' ) || ( docs[x]['codice'] == '2050D111' && practice.to_get_cadastral_data == '1' && practice.disposal == 'old' ) ){
          // DELEGA VISURA
          console.warn('Delete 2050D111 DELEGA VISURA')
          delete docs[x]
        }else if( ( docs[x]['codice'] == '2050D112' && practice.enea_request == '0' ) || ( docs[x]['codice'] == '2050D112' && practice.enea_request == '1' && practice.disposal == 'old' ) ){
          // DELEGA ENEA
          console.warn('Delete 2050D111 DELEGA ENEA')
          delete docs[x]
        }
        /*else if( ( docs[x]['codice'] == '2050D06D' && practice.flow == 'agileenergy' )  ){
          // DELEGA ENEA
          console.warn('Delete 2050D06D IF AGILE')
          delete docs[x]
        }*/
         else {
          var z = {}
          z.images = {}
          z.countImages = 0
          z.completed = 0

          z.docname = docs[x]['name']

          if ((_vue.getProfile.tipo_azienda == 'Ditta Individuale' || _vue.getProfile.tipo_azienda == 'Professionista iscritto ad albi') && docs[x]['codice'] == '2050D0B') {
            z.mandatory = 'no'
            docs[x]['mandatory'] = 'no'
          } else {
            z.mandatory = docs[x]['mandatory']
          }

          // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
          if (docs[x]['codice'] == '2050D11' && practice.to_get_cadastral_data == '1') {
            z.mandatory = 'no'
            docs[x]['mandatory'] = 'no'
          } else {
            if (docs[x]['codice'] == '2050D11' && practice.to_get_cadastral_data == '0') {
              z.mandatory = 'yes'
              docs[x]['mandatory'] = 'yes'
            } else {
              z.mandatory = docs[x]['mandatory']
            }

          }


          // NEWW REMOVE MANDATORY ID REQUEST ENEA
          if ( ( docs[x]['codice'] == '2050D15' && practice.enea_request == '1' ) || ( docs[x]['codice'] == '2050D15' && practice.bonus == 'Bonus Casa 50%' ) ) {
            z.mandatory = 'no'
            docs[x]['mandatory'] = 'no'
          } else {
            if (docs[x]['codice'] == '2050D15' && practice.enea_request == '0') {
              z.mandatory = 'yes'
              docs[x]['mandatory'] = 'yes'
            } else {
              z.mandatory = docs[x]['mandatory']
            }

          }


          z.hasError = 'no'
          for (var y in _vue.savedDocuments) {
            if (_vue.savedDocuments[y].codice == x) {
              z.images[_vue.savedDocuments[y].id] = _vue.savedDocuments[y].url
              z.countImages = 1
              z.date = _vue.savedDocuments[y].date
              z.completed = parseInt(_vue.savedDocuments[y].completed)
              z.hasError = _vue.savedDocuments[y].hasError
              z.error = _vue.savedDocuments[y].error
            }
          }
          z.percent = 0
          var y = {}
          y[x] = z
          Vue.set(_vue.uploadFrontPercentage, x, z)
        }
      }

      console.log(_vue.uploadFrontPercentage)

      console.warn(_vue.documents)

      _vue.loadingState = false
    },
    async forcereloadDocsOld() {
      var _vue = this;

      if (this.$route.params.item.flow == 'poste') {


        // NEW REMOVE 5 DOCUMENTS if OLD DL
        console.log( 'forcereloadDocs DL *******************' + this.item.dl )
        console.log(  documentsOR[this.$route.params.item.client_type] )
        if( this.item.dl == 'old' || ( this.$route.params.item.status != '1' && this.$route.params.item.dl == '0' ) ){
          console.log( 'forcereloadDocs DOC REMOVED' )

          this.documents = documentsOROld
        }else{
          this.documents = documentsOR
        }

      } else {

        // NEW REMOVE 5 DOCUMENTS if OLD DL
        if( this.item.dl == 'old' || ( this.$route.params.item.status != '1' && this.$route.params.item.dl == '0' ) ){
          console.log( 'forcereloadDocs DOC REMOVED' )
          this.documents = documents_cdpOROld
        }else{
          this.documents = documents_cdpOR
        }
      }

      if (process.env.PAYPAL_ENV == 'SANDBOX') {
        this.envPP = 'sandbox'
      }
      // DOC LIST PARSER
      var docTemp = this.documents[this.$route.params.item.client_type]
      this.documents[this.$route.params.item.client_type] = {}

      var selettore_titoloPossesso = this.$route.params.item.client_ownership
      var selettore_enea = this.$route.params.item.enea_request

      if (selettore_enea == '0') {
        selettore_enea = 'no'
      } else {
        selettore_enea = 'yes'
      }

      for (var ele in docTemp) {
        if (docTemp[ele].hasOwnProperty('codice')) {
          this.documents[this.$route.params.item.client_type][ele] = docTemp[ele]
        } else if (docTemp[ele].hasOwnProperty('selector')) {
          if (docTemp[ele]['selector'].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
            var tmpList = docTemp[ele]['selector'][selettore_titoloPossesso.toLowerCase()]
          } else if (docTemp[ele]['selector'].hasOwnProperty(selettore_enea)) {
            var tmpList = docTemp[ele]['selector'][selettore_enea.toLowerCase()]
          }
          for (var eleS in tmpList) {
            this.documents[this.$route.params.item.client_type][eleS] = tmpList[eleS]
          }
        }
      }


      // ******************************************************************************************


      this.loadingState = true
      //this.uploadFrontPercentage = {}

      Object.assign(this.uploadFrontPercentage, {})

      await this.getDocuments(this.$route.params.item.code, 'asdg2352rsdfgv')

      for (var x in this.documents[this.$route.params.item.client_type]) {
        if (this.$route.params.item.bonus == 'Bonus Casa 50%' && this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D19' && this.$route.params.item.client_type != 'Amministratore di condominio') {
          delete this.documents[this.$route.params.item.client_type][x]
        }else if( ( this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D111' && this.$route.params.item.to_get_cadastral_data == '0' ) || ( this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D111' && this.$route.params.item.to_get_cadastral_data == '1' && this.$route.params.item.disposal == 'old' ) ){
          // DELEGA VISURA
          delete this.documents[this.$route.params.item.client_type][x]
        }else if( ( this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D112' && this.$route.params.item.enea_request == '0' ) || ( this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D112' && this.$route.params.item.enea_request == '1' && this.$route.params.item.disposal == 'old' ) ){
          // DELEGA ENEA
          delete this.documents[this.$route.params.item.client_type][x]
        } else {
          var z = {}
          z.images = {}
          z.countImages = 0
          z.completed = 0

          z.docname = this.documents[this.$route.params.item.client_type][x]['name']

          if ((this.getProfile.tipo_azienda == 'Ditta Individuale' || this.getProfile.tipo_azienda == 'Professionista iscritto ad albi') && this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D0B') {
            z.mandatory = 'no'
            this.documents[this.$route.params.item.client_type][x]['mandatory'] = 'no'
          } else {
            z.mandatory = this.documents[this.$route.params.item.client_type][x]['mandatory']
          }

          // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
          if (this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D11' && this.$route.params.item.to_get_cadastral_data == '1') {
            z.mandatory = 'no'
            this.documents[this.$route.params.item.client_type][x]['mandatory'] = 'no'
          } else {
            if (this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D11' && this.$route.params.item.to_get_cadastral_data == '0') {
              z.mandatory = 'yes'
              this.documents[this.$route.params.item.client_type][x]['mandatory'] = 'yes'
            } else {
              z.mandatory = this.documents[this.$route.params.item.client_type][x]['mandatory']
            }

          }


          // NEWW REMOVE MANDATORY ID REQUEST ENEA
          if ( ( this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D15' && this.$route.params.item.enea_request == '1' ) || ( this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D15' && this.$route.params.item.bonus == 'Bonus Casa 50%' ) ) {
            z.mandatory = 'no'
            this.documents[this.$route.params.item.client_type][x]['mandatory'] = 'no'
          } else {
            if (this.documents[this.$route.params.item.client_type][x]['codice'] == '2050D15' && this.$route.params.item.enea_request == '0') {
              z.mandatory = 'yes'
              this.documents[this.$route.params.item.client_type][x]['mandatory'] = 'yes'
            } else {
              z.mandatory = this.documents[this.$route.params.item.client_type][x]['mandatory']
            }

          }


          z.hasError = 'no'
          for (var y in this.savedDocuments) {
            if (this.savedDocuments[y].codice == x) {
              z.images[this.savedDocuments[y].id] = this.savedDocuments[y].url
              z.countImages = 1
              z.date = this.savedDocuments[y].date
              z.completed = parseInt(this.savedDocuments[y].completed)
              z.hasError = this.savedDocuments[y].hasError
              z.error = this.savedDocuments[y].error
            }
          }
          z.percent = 0
          var y = {}
          y[x] = z
          Vue.set(this.uploadFrontPercentage, x, z)
        }
      }

      //console.log(this.uploadFrontPercentage)

      this.loadingState = false
    },
  },
  watch: {
    dl: function(val) {
      if (val) {
        this.recalcPrices('norm')
        this.forcereloadDocs()
      }
    },
    discount: function(val) {
      if (val) {
        this.discount = this.discount.toUpperCase()
      }
    },
    adress: function(val) {
      if (val) {
        this.adress = this.adress.toUpperCase()
      }
    },
    civic: function(val) {
      if (val) {
        this.civic = this.civic.toUpperCase()
      }
    },
    phone: function(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },
    getProfile: function() {
      //this.checkIfIban()
      this.forcereloadDocs()
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function(newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = ''
      this.cityError = false
      this.zipError = false

      if (newProvince) {
        this.citiesState = true
        axios({
            url: process.env.ROOT_API + 'api/getComuni',
            method: 'POST',
            data: {
              provincia: newProvince
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            this.cities = resp.data.cities
            this.citiesState = false
          })
          .catch(resp => {
            this.cities = [];
            this.citiesState = false
          })
      }

    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function(newCity) {
      this.zipError = false
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true
        axios({
            url: process.env.ROOT_API + 'api/getCap',
            method: 'POST',
            data: {
              istat: newCity.cityistat
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            this.zips = resp.data.zips;
            this.zipsState = false
          })
          .catch(resp => {
            this.zips = [];
            this.zipsState = false
          })
      }

    },
  },
  async created() {

    console.warn( " CREATED *************************************************************" )


    if (process.env.PAYPAL_ENV == 'SANDBOX') {
      this.envPP = 'sandbox'
    }

    if( this.getProfile ){
      this.forcereloadDocs()
    }



  },
  mounted() {
    this.loadButtons = true

    if (this.$route.params.item) {
      this.item = this.$route.params.item

      this.recalcPrices('norm')

      if (this.item.enea_cpid) {
        this.enea_cpid = this.item.enea_cpid
      }


      if (this.item && this.item.client_type != 'Amministratore di condominio') {
        this.address = this.item.building_address
        this.civic = this.item.building_civic
      }

      if (this.item.payment_id == 0) {
        this.payment = false

        var _vue = this



      } else {
        this.payment = true
      }

      this.loaded = true


      // NEW
      var _vue = this
      setTimeout(function() {
        _vue.concluded = true
        for (var p in _vue.uploadFrontPercentage) {

          if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
            _vue.concluded = false
          }
        }
      }, 1500)



    } else {
      this.$router.push('/pratiche')
    }

    //this.checkIfIban()

    this.populateProvincies()
    this.$scrollTo('#app', 700, {
      offset: -75
    })

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
    position: absolute;
    bottom: -37px;
    font-size: 17px;
    width: 100%;
    text-align: center;
    color: #0e3d8b!important;
    z-index: 12313;
    white-space: nowrap;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.customAccordion > dl > dt {
    box-shadow: none!important;
    padding: 0;
    margin-bottom: 0;
}

.customAccordion > dl > dt > div > button > .badger-accordion-title {
    flex: 0 0 94% !important;
}

.customAccordion > dl > dt > div > button > .badger-toggle-indicator {
    flex: 0 0 6% !important;
}
.borderTop {
    border-top: 3px solid #003d13;
    padding-top: 15px;
}

.shopIcon {
    width: 75px;
}

.bigTitle {
    font-size: 47px;
    color: #003d13;

    @media screen and (max-width: $phone) {
        font-size: 27px;
    }

}

.hideFileUpload {
    position: absolute;
    width: 100%;
    height: 110%;
    background: #000000;
    opacity: 0.4;
    top: -18px;
    left: 0;
    filter: blur(24px);
    z-index: 10000;
}

h5 {

    @media screen and (max-width: $phone) {
        font-size: 14px;
    }

}
.corporateImg {
    max-height: 153px;
}
.backImageInvoice {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    > img {
        max-height: 477px;
        margin: 0 auto;
        cursor: pointer;
    }
}

.zoomImage {
    position: absolute;
    left: 48%;
    top: 230px;
    cursor: pointer;
}

.vcenter {
    align-items: center;
    align-self: center;
    vertical-align: middle;
    display: inherit;
}

.front-image2 {

    position: relative;
    margin: 0 auto;
    display: block;
    height: 29px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 100%;
    margin-bottom: 0;
    background: #00897e!important;
    color: white;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;

    @media screen and (max-width: $tablet) {
        margin-top: 15px!important;
    }

    > .fileInputLabel {
        display: none;
    }

    > .invalid-feedback {
        display: block;
        position: absolute;
        bottom: 15px;
        font-weight: 800;
    }

    > input {
        position: absolute;
        filter: alpha(opacity=0);
        opacity: 0;
        left: 5px;
        width: 100%;
        height: 30px;
        z-index: 10;
        top: 0;

        cursor: pointer!important;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 99;
        /*This makes the button huge. If you want a bigger button, increase the font size*/
        font-size: 50px;
        /*Opacity settings for all browsers*/
        opacity: 0;
        -moz-opacity: 0;
        filter:progid:DXImageTransform.Microsoft.Alpha(opacity=0);

    }

    > label {
        /*display: none;*/
        cursor: pointer;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        position: relative;
        padding: 0!important !important;
        left: 0;

        > span {
            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            width: 100%;
            margin-top: 0 !important;
            display: block;
            height: 29px;
            margin: 0 auto;
            cursor: pointer;
            word-break: break-all;
            padding: 0;
            color: white;
            border-radius: 7px;
            overflow-wrap: break-word;
            white-space: normal;
            line-height: 19px;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            align-self: center;
            vertical-align: middle;
            margin: auto;
            display: inline-grid;
            background-size: cover;
            background-position: center;
            cursor: pointer;
            &:before {
                cursor: pointer;
                content: "CARICA";
                font-family: Regular;
                font-weight: 300!important;
                display: block;
                clear: both;
                text-align: center;
                height: 29px;
                width: 100%;
                border-radius: 7px;
                padding-top: 3px;
                font-size: 0.775rem !important;
                font-weight: 600;
                color: white;
                border: 3px solid #00917e;
                /*padding: .55rem .55rem !important;*/
                font-size: 0.775rem !important;
                line-height: 0.9 !important;
                border-radius: 0.1rem !important;
            }

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        &:after {
            content: "";
            display: block;

            clear: both;
            text-align: center;
            width: 100%;
            font-size: 10px;
            text-decoration: underline;
            color: black;
            cursor: pointer;
            /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        @media screen and (max-width: $phone) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }
        @media screen and (min-width: $phone) and (max-width: $tablet) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }

    }

}

.niceInputLabel2 {
    color: #ffffff !important;
    font-size: 21px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 0;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 0;
    text-overflow: ellipsis;
    max-width: 100%;
}

.center-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/loadDocuments/index.vue